import React from "react";

import { Select } from "antd";

import {
  renderSelectPopupScrollbar,
  selectPopupClassNames,
} from "../../../../Common/UIComponents/SelectPopupScrollbar";

import { ReactComponent as ChevronDown } from "../../../../../assets/images/common/ChevronDown.svg";
import "./SpecManagerSelect.css";

export default function SpecManagerSelect({
  options, // [{value, label, icon}, ...] if label is not given, value is used as the displayed label
  optionSelected,
  className = "",
  popupClassName = "",
  width,
  onSelect,
  placeholder,
}) {
  const selectOptions = options.map((item) => (
    {
      value: typeof item === "string" ? item : item.value,
      label: (
        <>
          {typeof item === "string" ? null : item.icon || null}
          {typeof item === "string" ? item : (item.label ?? item.value)}
        </>),
    }
  ));
  return (
    <Select
      /* outlined → fill/border/text from tokens.js `components.Select` */
      placeholder={placeholder}
      value={optionSelected}
      options={selectOptions}
      style={{ width }}
      onSelect={onSelect}
      suffixIcon={<ChevronDown className="EnvSpecManagerSelect__Chevron" />}
      className={`EnvSpecManagerSelect ${className}`}
      classNames={selectPopupClassNames(
        [`EnvSpecManagerSelect__Dropdown`, popupClassName].filter(Boolean).join(" "),
      )}
      virtual={false}
      listHeight={160}
      getPopupContainer={(trigger) => trigger.parentElement}
      popupRender={(menu) => renderSelectPopupScrollbar(menu, {
        optionCount: selectOptions.length,
      })}
    />
  );
}
